export const dropdownItemStyle = {
  general: {
    padding: ".25rem",
    cursor: "pointer"
  }
};
export default dropdownItemStyle;
